import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { RequestResult } from '@app/core/dto/RequestResult';
import { ReactiveFormsHelperService } from '@app/core/services/reactive-forms-helper.service';
import { SessionStorageService } from '@app/core/services/session-storage.service';
import { SpinnerService } from '@app/core/services/spinner.service';
import { RoomInformation } from '@app/kip/dto/RoomInformation';
import { RoomInformationService } from '@app/kip/services/room-information.service';
import { vwRoomState } from '@app/kip/viewdto/vwdailytask/vwRoomState';
import { RoomState } from '@app/shared/enums/roomstates';
import HwUtils from '@app/shared/helpers/hwutils';
import { TranslateService } from '@ngx-translate/core';
import { AutoUnsubscribe } from 'ngx-auto-unsubscribe';
import { Subscription } from 'rxjs';

@AutoUnsubscribe()
@Component({
  selector: 'room-information-dialog',
  templateUrl: './room-information-dialog.component.html',
  styleUrls: ['./room-information-dialog.component.scss']
})
export class RoomInformationDialogComponent implements OnInit, OnDestroy {
  _roomNumber: string;
  loaded: boolean = false;
  hasData: boolean = false;
  roomInformationData: RoomInformation = {
    Amenities: '',
    Comment: '',
    Equipments: '',
    NumberOfAdults: 0,
    NumberOfTeens: 0,
    NumberOfChildren: 0,
    NumberOfBabies: 0,
    NumberOfActiveBabies: 0,
    LateCheckOut: false
  }
  loadByRoomNumber$: Subscription;
  constructor(public dialogRef: MatDialogRef<RoomInformationDialogComponent>,
    @Inject(MAT_DIALOG_DATA) private roomState: vwRoomState,
    private roomInformationService: RoomInformationService,
    private sessionStorageService: SessionStorageService,
    private spinnerService: SpinnerService,
    private translate: TranslateService
  ) {

    this._roomNumber = this.roomState.RoomNumber;
  }

  ngOnInit(): void {
    this.spinnerService.setSpinnerVisibility(true);
    this.loadByRoomNumber$ = this.roomInformationService.LoadByRoomNumber(this.sessionStorageService.getSelectedUnit(),
      this.sessionStorageService.getSelectedHotelId(), this._roomNumber).subscribe(result => {
        let res: RequestResult = result as RequestResult;
        if (res.Data == null) {
          this.hasData = false;
        } else {
          this.hasData = true;
          this.roomInformationData = res.Data as RoomInformation;
          if (this.roomInformationData.Amenities == null) {
            this.roomInformationData.Amenities = '';
          }
          if (this.roomInformationData.Comment == null) {
            this.roomInformationData.Comment = '';
          }
          if (this.roomInformationData.Equipments == null) {
            this.roomInformationData.Equipments = '';
          }
        }
        this.loaded = true;
        this.spinnerService.setSpinnerVisibility(false);
      });
    this.spinnerService.setSpinnerVisibility(false);
  }

  ngOnDestroy(): void {
    this.loadByRoomNumber$?.unsubscribe();
  }

  submit() {
    this.dialogRef.close();
  }



  roomStateColorStyle() {
    let styles = {};
    if (this.roomState.RoomStateCode == RoomState.EMPTY_AVAILABLE || this.roomState.RoomStateCode == RoomState.RESERVED_OK) {
      styles["background-color"] = "#81c784";
    }
    if (this.roomState.RoomStateCode == RoomState.EMPTY_CLEAN || this.roomState.RoomStateCode == RoomState.RESERVED_CLEAN) {
      styles["background-color"] = "#03a9f4";
    }
    if (this.roomState.RoomStateCode == RoomState.EMPTY_DIRTY || this.roomState.RoomStateCode == RoomState.RESERVED_DIRTY) {
      styles["background-color"] = "#f35870";
    }

    if (this.roomState.RoomStateCode == RoomState.OUT_OF_SERVICE) {
      styles["background-color"] = "#ce93d8";
    }

    if (this.roomState.RoomStateCode == RoomState.OUT_OF_ORDER) {
      styles["background-color"] = "#424242";
    }

    if (this.roomState.RoomStateCode == RoomState.SHOW_ROOM) {
      styles["background-color"] = "#ffca28";
    }
    styles["height"] = "auto";
    return styles;
  }


  familyMembers() {
    let strFamily = HwUtils.zeroIfNull(this.roomInformationData.NumberOfAdults).toString() + '-' +
      HwUtils.zeroIfNull(this.roomInformationData.NumberOfTeens).toString() + '-' +
      HwUtils.zeroIfNull(this.roomInformationData.NumberOfChildren).toString() + '-' +
      HwUtils.zeroIfNull(this.roomInformationData.NumberOfBabies + this.roomInformationData.NumberOfActiveBabies).toString()
    return strFamily;

  }
}
